import {
  getG11nAndTranslationsFromServer,
  type TCustomGetServerSideProps,
} from '@crehana/next';

import { PAGE_KEY } from '../constants';
import locales from '../i18n';

const getServerSideProps: TCustomGetServerSideProps = async ({
  req,
  query,
}) => {
  const g11nData = await getG11nAndTranslationsFromServer({
    headers: req.headers,
    pageKey: PAGE_KEY,
    defaultTranslations: locales,
  });

  const { orgSlug } = query;
  const organizationSlug = orgSlug as string;

  return {
    props: {
      ...g11nData,
      organizationSlug,
    },
  };
};

export default getServerSideProps;
